import React from 'react';
import icon1 from '../../assets/img/AboutUs6/1.png';
import icon2 from '../../assets/img/AboutUs6/2.png';
import icon3 from '../../assets/img/AboutUs6/3.png';
import icon4 from '../../assets/img/AboutUs6/4.png';
import icon5 from '../../assets/img/AboutUs6/5.png';
import icon6 from '../../assets/img/AboutUs6/6.png';

const AboutUs6 = () => {
    const values = [
        {
            icon: icon1,
            title: "Our Values",
            desc: "At Scan to BIM, our values are the foundation of everything we do. They guide our mission to deliver cutting-edge digital architecture solutions while building trust, driving innovation, and exceeding client expectations"
        },
        {
            icon: icon2,
            title: "Respect",
            desc: "We foster a collaborative and inclusive environment by showing deep respect for our employees, clients, and users."
        },
        {
            icon: icon3,
            title: "Exceptional Value",
            desc: "We focus on delivering exceptional value to our customers through our industry knowledge and consultative approach."
        },
        {
            icon: icon4,
            title: "Authenticity",
            desc: "We build trust with clients and inspire meaningful work by valuing authenticity in all our interactions."
        },
        {
            icon: icon5,
            title: "Leadership",
            desc: "Our creative leaders inspire growth and innovation by promoting continuous learning and celebrating shared successes."
        },
        {
            icon: icon6,
            title: "Quest for Perfection",
            desc: "We strive for perfection in every task, achieving excellence with an unwavering focus on quality deliverables."
        }
    ];

    return (
        <section className="about-us6-section">
            <div className="about-us6-container">
                <div className="about-us6-header">
                    <h2 className="title"><span className="text-secondary">Guided</span> Values</h2>
                    <p className="desc centered">
                        At Chudasama outsourcing, our values are the foundation of everything we do. They guide our mission 
                        to deliver cutting-edge architecture digital solutions while building trust, driving innovation, and 
                        exceeding client expectations. Our core values include.
                    </p>
                </div>

                <div className="values-list-grid">
                    {values.map((item, index) => (
                        <div className="value-item-card" key={index}>
                            <div className="small-icon">
                                <img src={item.icon.src || item.icon} alt={item.title} />
                            </div>
                            <h3 className="subtitle">{item.title}</h3>
                            <p className="desc">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutUs6;
